import { useMemo } from 'react';
import { WebMap, Layer } from '../constructors';

const getLayersDisplayedInDropdown = (layersList: Layer[]): Layer[] =>
    layersList.filter((layer) => !!layer?.id && !!layer?.title && layer.id[0] !== '_');

export const useMapLayersDropdownUtils = (webMap: WebMap | undefined) =>
    useMemo(() => {
        const layersDisplayedInDropdown = getLayersDisplayedInDropdown(
            webMap?.layers.toArray() ?? []
        );
        const checkboxesOptions =
            layersDisplayedInDropdown?.map((layer) => ({
                value: layer?.id ?? '',
                label: layer?.title ?? '',
            })) ?? [];

        return { layersDisplayedInDropdown, checkboxesOptions };
    }, [webMap?.layers]);
